import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[idpStickyNavbar]',
  exportAs: 'idpStickyNavbar'
})
export class StickyNavbarDirective {
  reached = false;

  constructor(public elementRef: ElementRef) {}

  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    const elementPosition = this.elementRef.nativeElement.offsetTop - 20;
    const scrollPosition = window.scrollY;
    this.reached = scrollPosition >= elementPosition;
  }
}
